<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              Ввод данных идентификатора хранилища электронного документа
              (пакета электронных документов), переданного на хранение,
              указанный в свидетельстве
            </div>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="$v.storageFileIdsString.$model"
              :errorMessages="getValidationErrorText($v.storageFileIdsString)"
              v-mask="storageFileIdsTokens"
              outlined
              label="Ввод данных идентификатора хранилища электронного документа (пакета электронных документов), переданного на хранение, указанный в свидетельстве"
            />
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { dateRevers, formattingStorageFileIdsValue } from '@/utils/common';
import { maxLength, required } from 'vuelidate/lib/validators';

import { getValidationErrorText, STORAGE_FILE_IDS } from '@/utils/validate';
import { checkInvalid, leaveStep, Text } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { StorageIssueStep } from '@/constants';

export default {
  name: 'StorageFile',
  components: {
    Footer,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    storageFileIdsTokens: {
      mask: 'CCCC-CCCC-CCCC-CCCC-CCCC-CCCC-CCCC-CCCC',
      tokens: {
        C: {
          pattern: /[0-9a-zA-Z]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
      },
    },
    StepDirection,
    Text,
    dateRevers,
    StepName,
    leaveStep,
    getValidationErrorText,
    STORAGE_FILE_IDS,
    invalidFields: [],
    storageFileIdsString: '',
    storageIssueDetails: {
      storageFileId: '',
      note: '',
      hasPrivilege: false,
    },
  }),
  validations() {
    return {
      storageFileIdsString: {
        required,
        STORAGE_FILE_IDS,
        maxLength: maxLength(39),
      },
      storageIssueDetails: {
        storageFileId: '',
        hasPrivilege: false,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (ServicesModule.statement.storageIssueDetails) {
        this.storageFileIdsString =
          ServicesModule.statement.storageIssueDetails.storageFileId;
        this.storageIssueDetails = cloneDeep(
          ServicesModule.statement.storageIssueDetails
        );
      }
    },
    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      this.storageIssueDetails.storageFileId = formattingStorageFileIdsValue(
        this.storageFileIdsString
      );
      return {
        storageIssueDetails: {
          hasPrivilege: cloneDeep(this.storageIssueDetails.hasPrivilege),
          note: cloneDeep(this.storageIssueDetails.note),
          storageFileId: this.storageIssueDetails.storageFileId,
        },
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StorageIssueStep.STORAGE_FILE,
      });
    },
  },
};
</script>
